import Onboard from '@web3-onboard/core';
import injectedModule from '@web3-onboard/injected-wallets';
import walletConnectModule from '@web3-onboard/walletconnect';
import { BASE_CHAIN_PARAMS, WORKLOOB_NET } from './Constants';

// Single active chain — testnet or mainnet per REACT_APP_WORKLOOB_NETWORK
const activeChainIdHex = `0x${Number(BASE_CHAIN_PARAMS.chainId).toString(16)}`;

const chains = [
  {
    id: activeChainIdHex,
    token: BASE_CHAIN_PARAMS.nativeCurrency?.symbol || 'ETH',
    label: BASE_CHAIN_PARAMS.chainName || 'Base',
    rpcUrl: BASE_CHAIN_PARAMS.rpcUrls?.[0] || '',
  },
];

console.log(`[Workloob] Wallet network: ${WORKLOOB_NET.network} (${BASE_CHAIN_PARAMS.chainName}, chainId ${BASE_CHAIN_PARAMS.chainId})`);

const injected = injectedModule();

// Get current origin dynamically (works for both localhost and production)
const getCurrentOrigin = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'https://workloob.com'; // Fallback for SSR
};

const currentOrigin = getCurrentOrigin();

// App metadata for Onboard
// Note: Onboard's appMetadata doesn't accept 'url' property
// WalletConnect will use the URL from your WalletConnect Cloud project settings
const appMetadata = {
  name: 'workloob',
  description: 'Workloob dApp - Freelance Marketplace',
  icon: 'https://res.cloudinary.com/dxufkhffc/image/upload/v1771336417/workloob/gigs/cbpywm0a12nrr1u1p8j9.png',
  logo: 'https://res.cloudinary.com/dxufkhffc/image/upload/v1771336417/workloob/gigs/cbpywm0a12nrr1u1p8j9.png',
  gettingStartedGuide: 'https://workloob.com',
  explore: 'https://workloob.com',
};

// Initialize WalletConnect with proper configuration
let walletConnect = null;
try {
  // Get WalletConnect Project ID from environment variable
  // IMPORTANT: Get your Project ID from https://cloud.walletconnect.com
  // Create a free account and create a new project to get your Project ID
  const projectId = 'a65621cfeabeb4bf594e6a3b2c93a73a';
  
  // Validate project ID format (should be a valid UUID or hex string)
  if (!projectId || projectId.length < 10) {
    console.warn('⚠️ WalletConnect Project ID appears invalid. Please get a valid Project ID from https://cloud.walletconnect.com');
    console.warn('⚠️ WalletConnect will not work without a valid Project ID. Mobile users (Bybit, Binance, etc.) will not be able to connect.');
  }
  
  // WalletConnect v2 configuration for web3-onboard
  // This enables mobile wallet connections via QR code scanning
  // Note: metadata is passed to Onboard instance, not walletConnectModule
  walletConnect = walletConnectModule({
    projectId, // Required: Your WalletConnect Cloud Project ID
    // The metadata will be automatically used from the Onboard appMetadata config below
  });
  
  console.log('✅ WalletConnect module initialized successfully');
  console.log('📱 Mobile wallets (Bybit, Binance, Trust Wallet, etc.) are now available');
  console.log(`🌐 WalletConnect metadata URL: ${currentOrigin}`);
} catch (err) {
  // Don't crash the app if walletconnect fails to initialize; log and continue with injected wallets only.
  // eslint-disable-next-line no-console
  console.error('❌ walletConnectModule init error:', err && err.message ? err.message : err);
  console.warn('⚠️ WalletConnect will not be available. Please check your Project ID and configuration.');
  console.warn('⚠️ To fix: Get a Project ID from https://cloud.walletconnect.com and set REACT_APP_WALLETCONNECT_PROJECT_ID in your .env file');
  walletConnect = null;
}

const wallets = [injected];
if (walletConnect) wallets.push(walletConnect);

const onboard = Onboard({
  wallets,
  chains,
  appMetadata,
  accountCenter: {
    desktop: {
      enabled: false, // Disable account center if you have your own UI
    },
    mobile: {
      enabled: false, // Disable account center if you have your own UI
    },
  },
  notify: {
    enabled: true, // Enable notifications for transaction status
  },
});

export default onboard;
